import React from 'react';

export default function ExerciseInfoModal({
  showExerciseInfoModal,
  setShowExerciseInfoModal,
  theme,
  currentInfoExercise,
  exerciseInfoData,
  dbExercises,
  isLoadingExerciseInfo,
  isDark
}) {
  if (!showExerciseInfoModal) return null;
  const dbExercise = dbExercises[currentInfoExercise?.id] || {};
  const mediaUrl = currentInfoExercise?.video_url || currentInfoExercise?.image_url || currentInfoExercise?.img
    || dbExercise.video_url || dbExercise.image_url || dbExercise.img || null;
  const thumbnailUrl = currentInfoExercise?.thumbnail_url || dbExercise.thumbnail_url || null;
  const isVideo = Boolean(mediaUrl && (mediaUrl.includes('infografias') || /\.(mp4|webm|mov)(\?|$)/i.test(mediaUrl)));

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-6 animate-fadeIn overflow-y-auto">
      <div className={`${theme.card} border ${theme.border} rounded-[2.5rem] w-full max-w-md shadow-2xl my-auto relative overflow-hidden`}>
        
        <div className="relative flex items-center justify-center bg-black min-h-[16rem]">
          <button onClick={() => setShowExerciseInfoModal(false)} className="absolute top-4 right-4 text-white hover:text-red-500 font-bold text-xl drop-shadow-md z-20 bg-black/50 w-8 h-8 rounded-full flex items-center justify-center">✕</button>
          
          {isVideo ? (
             <video src={mediaUrl} poster={thumbnailUrl} autoPlay loop muted playsInline controls className="w-full h-full object-contain" />
          ) : (
            <>
              <img src={mediaUrl} alt={`Demostración de ${currentInfoExercise?.name || 'ejercicio'}`} className="w-full h-full object-cover opacity-60" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-6 z-10">
                <span className="text-[10px] text-emerald-400 font-bold uppercase tracking-widest block mb-1 drop-shadow-md">Guía Visual / Biomecánica IA</span>
                <h3 className="text-2xl font-black text-white leading-tight drop-shadow-md">{currentInfoExercise?.name}</h3>
              </div>
            </>
          )}
        </div>

        <div className="p-6">
          {isLoadingExerciseInfo ? (
            <div className="flex flex-col items-center justify-center py-10 space-y-4">
              <div className="w-10 h-10 border-4 border-t-emerald-500 border-emerald-500/20 rounded-full animate-spin"></div>
              <span className="text-xs text-emerald-500 font-bold animate-pulse">Analizando ejecución perfecta...</span>
            </div>
          ) : exerciseInfoData ? (
            <div className="space-y-6 animate-fadeIn">
              <div className="p-4 bg-emerald-500/10 border border-emerald-500/30 rounded-2xl">
                <span className="text-[10px] font-bold text-emerald-500 uppercase tracking-widest block mb-1">Qué hacer</span>
                <p className={`text-sm font-medium ${theme.text} leading-relaxed`}>{exerciseInfoData.summary}</p>
              </div>
              <div className={`p-4 ${theme.secondary} rounded-2xl border ${theme.border}`}>
                <span className={`text-[10px] ${theme.muted} font-bold uppercase tracking-widest block mb-2`}>Anatomía Implicada</span>
                <div className="space-y-2 text-xs">
                  <p><strong className="text-emerald-500">Principal:</strong> <span className={theme.text}>{exerciseInfoData.muscles?.primary}</span></p>
                  <p><strong className={theme.muted}>Secundarios:</strong> <span className={theme.text}>{exerciseInfoData.muscles?.secondary?.join(', ')}</span></p>
                </div>
              </div>

              <div>
                <span className={`text-[10px] ${theme.muted} font-bold uppercase tracking-widest block mb-3`}>Ejecución Paso a Paso</span>
                <ol className="space-y-3 max-h-48 overflow-y-auto pr-2">
                  {exerciseInfoData.execution?.map((step, i) => (
                    <li key={i} className="flex gap-3 text-xs font-medium leading-relaxed">
                      <span className="text-emerald-500 font-black">{i + 1}.</span>
                      <span className={theme.text}>{step}</span>
                    </li>
                  ))}
                </ol>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div className="p-3 bg-blue-500/10 border border-blue-500/30 rounded-2xl">
                  <span className="text-[9px] text-blue-500 font-bold uppercase block mb-1">Respiración</span>
                  <p className={`text-[10px] ${isDark ? 'text-blue-200' : 'text-blue-800'} font-medium leading-snug`}>{exerciseInfoData.breathing}</p>
                </div>
                <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-2xl">
                  <span className="text-[9px] text-red-500 font-bold uppercase block mb-1">Errores Comunes</span>
                  <ul className={`text-[10px] ${isDark ? 'text-red-200' : 'text-red-800'} font-medium leading-snug list-disc pl-3`}>
                    {exerciseInfoData.mistakes?.map((m, i) => <li key={i}>{m}</li>)}
                  </ul>
                </div>
              </div>

              <div className="p-4 bg-emerald-500/10 border border-emerald-500/30 rounded-2xl">
                <span className="text-[10px] font-bold text-emerald-500 uppercase tracking-widest block mb-1">💡 Mind-Muscle Connection</span>
                <p className={`text-xs font-medium ${isDark ? 'text-emerald-400' : 'text-emerald-700'} leading-relaxed`}>{exerciseInfoData.proTip}</p>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
